export const asRem = (val: number) => {
  return `${val}rem`;
};
